import { ReactElement, ReactNode } from 'react';
import { SContainer, STitle, SValue, SIcon } from './card.style';

const CardComponent = ({ icon, title, value }: {
  icon: ReactElement,
  title: ReactNode,
  value: ReactNode,
}): ReactElement => (
  <SContainer>
    <STitle>{title}</STitle>
    <SValue>{value}</SValue>
    <SIcon>{icon}</SIcon>
  </SContainer>
);

export default CardComponent;
